import { useRouter } from "next/router";
import { useEffect } from "react";
import { UseFormReturn, useForm, useWatch } from "react-hook-form";

import PageNav from "../components/common/pageNav.comp";
import Layout from "../components/layouts/layout.comp";
import MaterialListComp from "../components/material/materialList.comp";
import MaterialListFilterComp from "../components/material/materialListFilter.comp";
import Error from "../components/reuseables/error.comp";
import { ListSection } from "../components/reuseables/list.comp";
import { useTranslation } from "../core/translation.core";
import useMaterialQuery from "../hooks/useMaterialQuery";
import { MaterialListFilter } from "../types/material";
import AddLink from "../components/form/addLink.comp";

export default function MaterialsPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.material.materials)} titleBtn={<TitleBtns />}>
      <Error />
      <Content />
    </Layout>
  );
}

function TitleBtns() {
  const { t, msg } = useTranslation();

  return (
    <div className="flex gap-2 items-center">
      <AddLink id="material-create" href="/materials/create" />
    </div>
  );
}

function Content() {
  const { query, isReady } = useRouter();
  const methods = useForm<MaterialListFilter>({
    defaultValues: {
      page: 1,
      pageSize: 20,
      sort: "name",
      sortAsec: 1,
      categoryIds: [],
    },
  });

  // sync the page param back to form hook
  useEffect(() => {
    methods.setValue("page", Number(query.page ?? 1));
    // eslint-disable-next-line
  }, [query, isReady]);

  return (
    <>
      <MaterialListFilterComp methods={methods} />
      <ListSection>
        <MaterialListComp methods={methods} />
      </ListSection>
      <Paging methods={methods} />
    </>
  );
}

function Paging({ methods }: { methods: UseFormReturn<MaterialListFilter, any> }) {
  const router = useRouter();
  const [pageSize] = useWatch({
    name: ["pageSize"],
    control: methods.control,
  });
  const { data: products } = useMaterialQuery(methods);

  const total = products?.size;

  return <PageNav page={Number(router.query.page) || 1} size={pageSize} total={total ?? 0} pathname="/materials" />;
}
